const Table = ({ headers, items, footer = <></> }) => {
    const id = Math.random().toString(16).slice(-4);

    return (
        <div className="flex flex-col px-4">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 inline-block">
                    <div className="overflow-hidden">
                        <table>
                            <thead className="border-b">
                                <tr>
                                    {headers.map((head, index) => (
                                        <th
                                            key={`table-head-item-${head}-${index}-${id}`}
                                            scope="col"
                                            className="text-sm font-bold text-gray-900 px-6 py-4 text-left whitespace-nowrap"
                                        >
                                            {head}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, index) => (
                                    <tr
                                        className="border-b"
                                        key={`table-row-item-${index}-${id}`}
                                    >
                                        {item.map((value, index) => (
                                            <td
                                                className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                                key={`table-row-value-item-${value}-${index}-${id}`}
                                            >
                                                {value}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                            {footer}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Table;
